"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import _ from "lodash";
let BatchEditGroup = class extends Vue {
  get show() {
    if (this._controller.query.filter.group === "vdgroup_system_recycle") {
      return false;
    }
    return true;
  }
  editGroup() {
    let arr = _.map(this._controller.selected, "id");
    this.$emit("editGroup", arr);
  }
};
__decorateClass([
  PropSync("controller")
], BatchEditGroup.prototype, "_controller", 2);
BatchEditGroup = __decorateClass([
  Component({
    components: {}
  })
], BatchEditGroup);
export {
  BatchEditGroup as default
};
